import { render, staticRenderFns } from "./StateInfo.vue?vue&type=template&id=4affecc3&scoped=true&"
import script from "./StateInfo.vue?vue&type=script&lang=ts&"
export * from "./StateInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StateInfo.vue?vue&type=style&index=0&id=4affecc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4affecc3",
  null
  
)

component.options.__file = "StateInfo.vue"
export default component.exports